import { Component, OnInit } from '@angular/core';
import { CartItemComponent, ProductService, CartService, PriceService } from 'gung-standard';

@Component({
    selector: 'ref-ref-cart-item',
    templateUrl: './ref-cart-item.component.html',
    styleUrls: ['./ref-cart-item.component.scss'],
    standalone: false
})
export class RefCartItemComponent extends CartItemComponent implements OnInit {
  constructor(
    public productService: ProductService,
    protected cartService: CartService,
    protected priceService: PriceService
  ) {
    super(productService, cartService, priceService);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
